<template>
  <div>
    <v-dialog
      v-for="dialog in dialogs"
      :key="dialog.key"
      :value="true"
      :width="dialog.width"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :persistent="dialog.persistent"
      :retain-focus="false"
      scrollable
      @click:outside="closeOutside(dialog)"
    >
      <v-card class="field-editor-dialog-card">
        <v-card-title class="field-editor-dialog-title py-2 px-3 grey lighten-4">
          <v-icon left color="indigo">mdi-form-textbox</v-icon>
          <span class="text-subtitle-1 font-weight-medium">{{ dialog.title }}</span>
          <v-spacer />
          <v-btn icon @click="close(dialog.key)"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="field-editor-dialog-content pa-0">
          <FieldEditor
            v-if="dialog.type === 'field'"
            :field-id="dialog.fieldId"
            :field-name="dialog.fieldName"
            :table="dialog.table"
            :context-key="dialog.key"
            embedded
            @saved="saved(dialog, $event)"
          />
          <FieldVariantEditor
            v-else
            :field-id="dialog.fieldId"
            :variant="dialog.variant"
            :context-key="dialog.key"
            embedded
            @saved="variantSaved(dialog, $event)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldEditor from './Field.vue'
import FieldVariantEditor from './editVariant.vue'
import { closeFieldEditor, fieldEditorDialogs, notifyFieldSaved } from './navigation'

export default {
  name: 'FieldEditorDialogHost',
  components: { FieldEditor, FieldVariantEditor },
  computed: {
    dialogs() {
      return fieldEditorDialogs.items
    },
  },
  methods: {
    close(key) {
      closeFieldEditor(key)
    },
    closeOutside(dialog) {
      if (!dialog.persistent) this.close(dialog.key)
    },
    saved(dialog, field) {
      notifyFieldSaved(dialog.key, field)
    },
    variantSaved(dialog, field) {
      notifyFieldSaved(dialog.key, field)
      this.close(dialog.key)
    },
  },
}
</script>

<style scoped>
.field-editor-dialog-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  max-height: 900px;
  overflow: hidden;
}

.field-editor-dialog-title {
  flex: 0 0 auto;
}

.field-editor-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none !important;
  overflow-y: auto;
  overscroll-behavior: contain;
}

@media (max-width: 600px) {
  .field-editor-dialog-card {
    height: 100vh;
    height: 100dvh;
    max-height: 100vh;
    max-height: 100dvh;
    border-radius: 0;
  }
}
</style>
